const applicationDetailsDictionary = {
  getApplicationLoanDetails: () =>
    `api/v1/partner/get-application-loan-details-by-id`,
  getAcademicDetails: () =>
    `api/v1/partner/get-applicant-education-details-by-application-id`,
  getEmploymentDetails: () => `api/v1/partner/get-applicant-employment-details`,
  getEntranceDetails: () =>
    `api/v1/partner/get-entrance-exam-details-by-applicant-id`,
  getLoanDetails: () => `api/v1/partner/get-loan-details-by-applicant-id`,
  getExpenseDetails: () =>
    `api/v1/partner/get-application-expense-funds-details-by-application-id`,
  getAdditionalDetails:()=> `api/v1/processio/getLoanDetailsFromProcessio`,
  getReferenceDetails: () =>
    `api/v1/partner/get-application-reference-details-by-application-id`,
  getCoApplicantDetails: () =>
    `api/v1/partner/get-all-coapplicants-by-application-id`,
  getCoApplicantBasicDetails: () =>
    `api/v1/partner/get-coapplicant-basic-details-by-applicant-id`,
  getCoApplicantCompletionRate: () =>
    `api/v1/user-application/coapplicant-completion-rate`,
  getCollateralDetails: () =>
    `api/v1/partner/get-application-collateral-details`,
  deleteCoApplicant: () => `api/v1/applicant/delete-coapplicant`,
  //processioDeleteCoApplicant: () => `api/v1/processio/delete-co-applicant`,
};

export default applicationDetailsDictionary;
